<ca-modal-container modalTitle="{{ title || ('CONTACT_US.HEADER_TITLE' | translate) }}" (dismiss)="dismiss($event)">
    <section *ngIf="description" header>
        <span class="text-medium-emphasis">{{ description }}</span>
    </section>
    <form [formGroup]="contactUsForm" (ngSubmit)="contactUsForm.valid && submit()" novalidate>
        <div class="d-flex flex-column-reverse mb-3">
            <input
                type="text"
                formControlName="fullName"
                class="form-control ca-text-primary"
                id="name"
                [placeholder]="'CONTACT_US.FORM.NAME_PLACEHOLDER' | translate"
                name="name"
                data-uit="contact-us-full-name-input"
            />
            <label for="name">{{ 'CONTACT_US.FORM.NAME' | translate }}</label>
        </div>
        <div class="d-flex flex-column-reverse mb-3">
            <input
                type="email"
                formControlName="email"
                class="form-control ca-text-primary"
                id="email"
                [placeholder]="'CONTACT_US.FORM.EMAIL_PLACEHOLDER' | translate"
                name="email"
                data-uit="contact-us-email-input"
            />
            <label for="email">{{ 'CONTACT_US.FORM.EMAIL' | translate }}</label>
        </div>
        <div class="mb-3">
            <div class="d-flex flex-column-reverse">
                <textarea
                    class="form-control p-3"
                    formControlName="message"
                    id="message"
                    [placeholder]="messagePlaceholder || ('CONTACT_US.FORM.MESSAGE_PLACEHOLDER' | translate)"
                    name="message"
                    data-uit="contact-us-message"
                    required
                    caAutoFocus
                    [ngClass]="messageControl?.errors?.required && messageControl?.dirty ? 'has-error' : ''"
                ></textarea>
                <label for="message">{{ messageLabel || 'CONTACT_US.FORM.MESSAGE' | translate }} <span class="red ps-1">*</span></label>
            </div>
            <small class="invalid-feedback" *ngIf="messageControl?.errors?.required && messageControl?.dirty">{{ 'GENERAL.REQUIRED_FIELD' | translate }}</small>
        </div>
        <div class="mb-3" *ngIf="showSendCopy">
            <ca-input-checkbox formControlName="send_copy_to_sender" name="needCopy" class="align-self-center">{{
                'CONTACT_US.FORM.SEND_EMAIL_COPY' | translate
            }}</ca-input-checkbox>
        </div>
        <button type="submit" [disabled]="!contactUsForm.valid" class="btn btn-primary w-100" data-uit="contact-us-send-button">
            {{ buttonText || ('GENERAL.SEND' | translate) }}
        </button>
    </form>
</ca-modal-container>
